import { NewsletterBlock, Layout, Slogan, Pictures, ContactForm } from '../util/modules';

export const Home = () => {

    return <div>
            <Layout>
                <main>
                    <NewsletterBlock />
                    <Slogan />
                    <Pictures />
                    <ContactForm />
                </main>
            </Layout>
        </div>;
}